import React, {useState, useEffect} from "react";
import {
    Input,
    RichInput,
    CheckBoxStyle,
    CheckboxWrapper,
    CheckBoxLabel,
    RadioButton,
    RadioWrapper,
    Dropdown,
} from "BaseComponents/Form";
import {Shake} from "Animations";
import {FormField, Label} from "./FormComponents";
import {ErrorField, ErrorText} from "./ErrorComponents";
import {get} from "react-hook-form";
import {ErrorMessage} from "@hookform/error-message";

export const Field = ({
                          errors,
                          register,
                          Label: Text,
                          Required,
                          FieldType,
                          RequiredText,
                          DefaultErrorText,
                          EmailErrorText,
                          Items,
                          MaxSelectionOptions,
                          MaxSelectionOptionsText,
                          getValues,
                          setError,
                          clearErrors,
                          setValue,
                      }) => {
    const [shake, setShake] = useState(false);
    const [name, setName] = useState(Text);
    const EMAIL = "E-mail";
    const GetPattern = () => {
        switch (FieldType) {
            case EMAIL:
                return {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i,
                    message: EmailErrorText,
                };

            default:
                return {
                    message: DefaultErrorText,
                };
        }
    };
    let registerRef = Required
        ? register({
            required: RequiredText,
            pattern: GetPattern(),
        })
        : register({required: false});

    let error = get(errors, Text) != undefined;
    useEffect(() => {
        if (error) {
            setShake(true);
            setTimeout(() => {
                setShake(false);
            }, 1000);
        }
    }, [errors]);

    const validateCheckList = (value, category) => {
        if (getValues && MaxSelectionOptions && MaxSelectionOptions !== 0) {
            const formValues = getValues();
            const cat = formValues[category];
            if (cat) {
                let filterValues = [];
                if (typeof cat === "object") {
                    var map = Object.keys(cat).map((key) => cat[key]);
                    filterValues = map.filter((c) => c);
                } else if (typeof cat === "string") {
                    filterValues = [cat];
                } else {
                    filterValues = cat.filter((c) => c);
                }
                const valid =
                    !filterValues || filterValues.length <= MaxSelectionOptions;
                if (!valid && setError) {
                    const message = MaxSelectionOptionsText.replace(
                        "{VALUE}",
                        MaxSelectionOptions
                    );
                    setError(category, {
                        type: "maxSelectionOptions",
                        message: message,
                    });
                } else if (valid && clearErrors) {
                    clearErrors(category);
                }
                return (
                    (valid &&
                        Required &&
                        filterValues.length !== cat.length &&
                        filterValues.length > 0) ||
                    (!Required && valid)
                );
            }
            return value && Required;
        }
        return value && Required;
    };

    return (
        <FormField
            error={error}
            shake={shake}
            row={FieldType == "Checkbox"}
            center={FieldType == "Checkbox"}
            smallRow={FieldType == "Checkbox"}
        >
            <Label
                htmlFor={name}
                error={error}
                removeMarginBottom={FieldType == "Checkbox"}
                addMarginRight={FieldType == "Checkbox"}
            >
                {Text}
                {Required && "*"}
            </Label>
            <Shake animate={shake}>
                <ErrorField>
                    {FieldType == "Rich text" ? (
                        <RichInput height="120px" name={Text} ref={registerRef}></RichInput>
                    ) : FieldType == "Checkbox" ? (
                        <CheckboxWrapper>
                            <CheckBoxStyle
                                ref={registerRef}
                                type="checkbox"
                                id={name}
                                name={name}
                            ></CheckBoxStyle>
                            <CheckBoxLabel role={'checkbox'} tabIndex="-1" htmlFor={name}></CheckBoxLabel>
                        </CheckboxWrapper>
                    ) : FieldType == "CheckboxList" ? (
                        <div
                            name={Text}
                            key={Text}
                            ref={register(Text, {required: false})}
                        >
                            {Items.map((c) => {
                                const name = `${Text}.${c}`;
                                return (
                                    <CheckboxWrapper
                                        key={`form-field-checkboxList-${Text}-${c}`}
                                        displayLayout="flex"
                                        alignItems="center"
                                    >
                                        <span>{c}</span>
                                        <CheckBoxStyle
                                            type="checkbox"
                                            id={name}
                                            key={name}
                                            name={name}
                                            ref={register({
                                                required: Required && MaxSelectionOptions === 0,
                                                validate: (value) => validateCheckList(value, Text),
                                            })}
                                        ></CheckBoxStyle>
                                        <CheckBoxLabel role="checkbox" tabIndex="-1" htmlFor={name}></CheckBoxLabel>
                                    </CheckboxWrapper>
                                );
                            })}
                            <ErrorText margin="7px 0 0 0" error={error}>
                                <ErrorMessage errors={errors} name={Text}/>
                            </ErrorText>
                        </div>
                    ) : FieldType == "Dropdown" ? (
                        <Dropdown
                            name={Text}
                            register={register(Text, {
                                required: Required ? RequiredText : false,
                            })}
                            items={Items?.map((option) => ({
                                label: option,
                                value: option,
                            }))}
                            onChange={(e) => {
                                setValue(Text, e.value);
                            }}
                        />
                    ) : FieldType == "RadioButton" ? (
                        <RadioWrapper flexDirection={"row"}>
                            {Items.map((c) => {
                                const name = `${Text}.${c}`;
                                return (
                                    <RadioButton
                                        tabIndex="0"
                                        label={c}
                                        id={name}
                                        key={name}
                                        name={Text}
                                        register={register({
                                            required:
                                                Required && MaxSelectionOptions === 0
                                                    ? RequiredText
                                                    : false,
                                            validate: (value) => validateCheckList(value, Text),
                                        })}
                                    />
                                );
                            })}
                        </RadioWrapper>
                    ) : (
                        <Input
                            name={name}
                            ref={registerRef}
                            height="40px"
                            type="text"
                        ></Input>
                    )}
                    {FieldType != "CheckboxList" && (
                        <ErrorText
                            margin={"0"}
                            bottom={"-20px"}
                            error={error}
                            position={FieldType == "Checkbox"}
                        >
                            <ErrorMessage errors={errors} name={Text}/>
                        </ErrorText>
                    )}
                </ErrorField>
            </Shake>
        </FormField>
    );
};
